import { router } from "@inertiajs/react";
import { ROUTES } from "app/frontend/constants/routes";
import { useParams } from "app/frontend/hooks/useParams";
import { useCallback } from "react";

export const useContactUs = () => {
    const params = useParams();
    return useCallback(() => {
        router.visit(ROUTES.Contact, {
            data: params,
        });
    }, [params]);
};
